<template>
  <BaseDialog isOpen>
    <template v-slot:title>
      Are you sure you want to accept the offer?
    </template>
    <template v-slot:actions>
      <div>
        <PrimaryButton @click.native="cancel" text>
          Cancel
        </PrimaryButton>
        <PrimaryButton @click.native="handleSubmit" :loading="isLoading">
          Accept Offer
        </PrimaryButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import { ACCEPT_OFFER } from "@/store/modules/offers/actions";

const { mapActions } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  name: "AcceptOfferDialog",
  components: { PrimaryButton, BaseDialog },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    currentOfferId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapActions({
      acceptOffer: ACCEPT_OFFER
    }),
    async handleSubmit() {
      this.isLoading = true;
      await this.acceptOffer(this.currentOfferId);
      this.cancel();
      this.isLoading = false;
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
